<app-ui-toast-message uiToastError message="Något gick fel i kommunikationen med databasen"
  header="Data kunde inte laddas"></app-ui-toast-message>
